import script from "./StudentNoteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentNoteModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__